import React from 'react';
import { Form, Formik } from 'formik';
import { FolderArrowDownIcon } from '@heroicons/react/24/outline';
import { BodyTextTW } from 'tailwindComponents/bodyText/BodyTextTW';
import { ButtonTW } from 'tailwindComponents/buttonTW/ButtonTW';
import { ISigningAppointmentEditFormData } from 'types/signingAppointment/ISigningAppointmentEditFormData';
import { Show } from '../../../../shared/Show';
import { TextAreaFieldTW } from '../../../../../tailwindComponents/textAreaTW/TextAreaFieldTW';
import { useSelectAppointmentFromPathParam } from '../../../../../utilities/order/scheduling/useSomeAppointmentFromParam';
import { isNil } from 'lodash';

export interface IEditAppointmentNotesFormProps {
  onSaveEditions: (formData: ISigningAppointmentEditFormData) => Promise<void>;
  setDoEditNotes: (doEdit: boolean) => void;
}

export const EditAppointmentNotesForm: React.FC<IEditAppointmentNotesFormProps> = ({
  onSaveEditions,
  setDoEditNotes,
}) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  if (!appointmentFromPath) {
    return null;
  }
  return (
    <Formik
      initialValues={{
        id: appointmentFromPath.id,
        notes: appointmentFromPath.notes,
      }}
      onSubmit={async (values: ISigningAppointmentEditFormData) => {
        await onSaveEditions(values);
        setDoEditNotes(false);
      }}
      enableReinitialize
    >
      {(formik) => (
        <Form>
          <TextAreaFieldTW name={'notes'} maxLength={250} />
          <Show when={!isNil(formik.values.notes)}>
            <BodyTextTW className={'text-red-800'}>
              Characters remaining: {250 - (formik.values.notes?.length ?? 0)}
            </BodyTextTW>
          </Show>
          <div className={'flex justify-items-center pt-3'}>
            <ButtonTW secondary onClick={() => formik.handleSubmit()}>
              <div className={'flex justify-start'}>
                <FolderArrowDownIcon className={'mr-1 h-5 w-5'} />
                <BodyTextTW>Save Note</BodyTextTW>
              </div>
            </ButtonTW>

            <ButtonTW
              className={'ml-2'}
              secondary={true}
              ghost={true}
              onClick={() => {
                setDoEditNotes(false);
              }}
            >
              Cancel
            </ButtonTW>
          </div>
        </Form>
      )}
    </Formik>
  );
};
